import i18nFactory from '@yandex-int/i18n';
import { Button } from 'lego-on-react';
import * as React from 'react';

import { Bem } from '../../../service/Bem/Bem';
import { formatNumber } from '../../../service/FormatHelpers/FormatHelpers';
import { pluralizeWord } from '../../../service/Pluralize/Pluralize';
import { GdRecommendationStatus } from '../../../typings/graphql-grid';
import { Kpi, RecommendationCharacter, RecommendationType } from '../../../typings/recommendations';
import { RecommendationItemsList } from '../../RecommendationItemsList/RecommendationItemsList';
import { RecommendationKpiInfo, RecommendationKpiType } from '../../RecommendationKpiInfo/RecommendationKpiInfo';
import { Shape2Icon } from '../../Shape2/Shape2';
import { RecommendationCard, RecommendationCardView } from '../RecommendationCard';

import * as keyset from './RemovePagesFromBlackListRecommendationCardGridPopup.i18n';

const i18n = i18nFactory(keyset);

export interface RemovePagesFromBlackListRecommendationCardGridPopupProps {
    kpi: Kpi;
    character: RecommendationCharacter;
    icon: Shape2Icon;
    status: GdRecommendationStatus;
    pagesNumber: number;
    isApplicable: boolean;
    onAcceptClick: () => void;
    onShow?: (view: RecommendationCardView, type: RecommendationType) => void;
    pages?: Array<string>;
}

export class RemovePagesFromBlackListRecommendationCardGridPopup extends React.PureComponent<
    RemovePagesFromBlackListRecommendationCardGridPopupProps
> {
    render() {
        const {
            status,
            isApplicable,
            character,
            icon,
            kpi: { periodValue, clicks, cost, sign, currency },
            onShow
        } = this.props;

        return (
            <RecommendationCard
                type={RecommendationType.removePagesFromBlackList}
                view={RecommendationCardView.recommendationsPopup}
                icon={icon}
                character={character}
                title={this.getTitle()}
                titleHint={this.getTitleHint()}
                descriptionInfo={this.getDescriptionInfo()}
                buttons={this.getButtons()}
                isInProgress={status === GdRecommendationStatus.IN_PROGRESS}
                progressHint={this.getProgressHintText()}
                isApplicable={isApplicable}
                onShow={onShow}
            >
                <RecommendationKpiInfo
                    currency={currency}
                    periodValue={periodValue}
                    kpi={{
                        type: RecommendationKpiType.clicks,
                        value: clicks
                    }}
                    cost={cost}
                    sign={sign}
                />
            </RecommendationCard>
        );
    }

    private getDescriptionInfo = () => {
        const { pages, pagesNumber } = this.props;

        if (!pages) {
            return null;
        }

        return (
            <RecommendationItemsList
                cls={Bem.cls('remove-pages-from-black-list-recommendation-card', 'items-description')}
                type={RecommendationType.removePagesFromBlackList}
                items={pages}
                totalNumber={pagesNumber}
            />
        );
    };

    private getTitle = (): string => {
        const itemsLength = this.props.pagesNumber;
        const formattedItemsLength = formatNumber(itemsLength);

        return pluralizeWord(
            [
                i18n('one-page-title', { count: formattedItemsLength }),
                i18n('some-pages-title', {
                    count: formattedItemsLength
                }),
                i18n('many-pages-title', { count: formattedItemsLength })
            ],
            itemsLength
        );
    };

    private getTitleHint = (): string => {
        return i18n('title-hint');
    };

    private getButtons = () => {
        const props = this.props;

        return [
            <Button
                key={1}
                theme={'action'}
                size={'n'}
                disabled={!props.isApplicable}
                onClick={props.onAcceptClick}
                text={i18n('accept-button')}
            />
        ];
    };

    private getProgressHintText = (): string => {
        return i18n('simple-progress-hint');
    };
}
